module.exports = __webpack_public_path__ + "static/media/Daedap Translated by J_Lee_77777.4e6d48a1.md";